module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av623-72644df51fd2c0f9f9471c3192127ba6.jpg";